import React, { Component } from 'react'

export class UserBannerSupportPanel extends Component<object> {
  static displayName = 'UserBannerSupportPanel'

  render() {
    return (
      <div className="user-banner__support-panel">
        <p>You can do it!</p>
      </div>
    )
  }
}
